import React, {Component} from "react";
import mailFeedback from "../../source/image/mail_feedback.png";
import {BridgeHelper} from "../../utils/bridgeHelper";
import {languagePackage} from "../../common/language";

export default class FeedbackConfirm extends Component {

    backToHome = () => {
        BridgeHelper.popToRoot();
        BridgeHelper.switchToTab(0, 1000);
    }

    render() {
        return (
            <div className={'w-screen h-screen flex flex-col items-center p-5 pt-24'}>
                <img className={'w-full'} src={mailFeedback} alt={""}/>
                <p className={'mt-8 font-bold text-xl text-primary'}>{languagePackage().ThanksForYourFeedback}</p>
                <p className={'mt-6 font-normal text-base text-textGray'}>{languagePackage().OurSupportTeamIsOnIt}</p>
                <p className={'font-normal text-base text-textGray text-center'}>{languagePackage().YouWillGetEmailReplySoon}</p>
                <div
                    className={'flex flex-col justify-center items-center h-12 rounded-full px-6 py-2.5 mt-8 bg-primary'}
                    onClick={this.backToHome}
                >
                    <p className={'font-semibold text-base text-white'}>{languagePackage().BackToHome}</p>
                </div>
            </div>
        )
    }
}
